import type { RouteLocationRaw } from 'vue-router'

export const useIsExternalUrl = (to: string | RouteLocationRaw): boolean | null => {
  if (!to) return null

  // Get the URL
  const url = typeof to === 'string' ? to : (to as { path?: string }).path || ''

  const regex = /^(https?:\/\/|www\.)/

  const isAbsoluteUrl = regex.test(url)

  if (!isAbsoluteUrl) {
    return false
  }

  const config = useRuntimeConfig()
  const appUrl = config.public.APP_URL || ''

  if (appUrl && url.includes(appUrl)) {
    // If an absolute URL contains the app's base URL, it's not external
    return false
  }

  return true
}
